import React from "react";
import Navbar from "./Navbar";
import "../css/Header.css";
import Image from "../Images/logo.png";
import WA from "../Images/WA.png";
import { Link } from "react-router-dom";

const Header = () => {
  return (<>
    <div className="header">
      <div className="header__left">
        <a href = "https://trisquare.asia/en/"><img className="header__logo" src={Image} alt="" /></a>
      </div>
      <div className="header__right">
        <Navbar />
      </div>
    </div>
    <div classname = "bottom__icon">
      <a href = "https://web.whatsapp.com/send?phone=8613817562813&text="><img className="WA__icon" src={WA} alt="" /></a>
      <div className = "bottomSpan">
      <a href = "https://web.whatsapp.com/send?phone=8613817562813&text="><img className="WA__icon1" src={WA} alt="" /></a>

      </div>
    </div>
    </>
  );
};
export default Header;
